import { FacebookIcon, InstagramIcon } from '../PlatformIcon';

interface CrossPostToggleProps {
  /** The platform the post will be copied to. */
  platform: 'facebook' | 'instagram';
  checked: boolean;
  onChange: (next: boolean) => void;
  disabled?: boolean;
  hint?: string | null;
}

/** Switch that copies this post to the other connected social account. */
export default function CrossPostToggle({
  platform,
  checked,
  onChange,
  disabled = false,
  hint = null,
}: CrossPostToggleProps) {
  const label = platform === 'facebook' ? 'Facebook' : 'Instagram';
  const Icon = platform === 'facebook' ? FacebookIcon : InstagramIcon;

  return (
    <div
      className={`flex items-center justify-between gap-3 rounded-2xl border border-gray-200 bg-white px-4 py-3 ${
        disabled ? 'opacity-50' : ''
      }`}
    >
      <div className="flex items-center gap-2.5 min-w-0">
        <Icon className="h-7 w-7 shrink-0" />
        <div className="min-w-0">
          <p className="text-[15px] font-medium text-gray-900">Also post to {label}</p>
          {hint ? <p className="text-[12px] text-gray-500 mt-0.5">{hint}</p> : null}
        </div>
      </div>
      <button
        type="button"
        role="switch"
        aria-checked={checked}
        aria-label={`Also post to ${label}`}
        disabled={disabled}
        onClick={() => onChange(!checked)}
        className={`relative inline-flex h-6 w-11 shrink-0 rounded-full transition-colors disabled:cursor-not-allowed ${
          checked ? 'bg-blue-600' : 'bg-gray-300'
        }`}
      >
        <span
          className={`inline-block h-5 w-5 transform rounded-full bg-white shadow transition mt-0.5 ${
            checked ? 'translate-x-5' : 'translate-x-0.5'
          }`}
        />
      </button>
    </div>
  );
}
